import { API } from 'aws-amplify';
import { mannaApiHost, apiKey } from '../constants';
import axios from 'axios';
import { OrdersApi } from '@flipdish/api-client-typescript';
import {
  API_DATA_REQUESTED,
  API_ERROR,
  ORDER_RECEIVED,
  ORDERS_RECEIVED,
  MISSION_RECEIVED,
  MISSIONS_RECEIVED,
  ORDER_CREATED,
  ORDER_STATUS_UPDATED,
  QUEUE_NOTIFICATION,
  LOADING,
  LOADING_DONE,
  LANDING_ZONES_RECEIVED,
  ORDER_TRACKING_RECEIVED,
  ORDERS_MERGED,
  MERGED_ORDERS_RECEIVED,
  ORDER_ACCEPTED_SUCCESS,
  ORDER_ACCEPTED_FAILURE,
  ORDER_ACCEPTED_REQUEST,
  ORDER_REJECTED_REQUEST,
  ORDER_REJECTED_SUCCESS,
  ORDER_REJECTED_FAILURE,
  ORDER_REFUNDED_REQUEST,
  ORDER_REFUNDED_FAILURE,
  ORDER_REFUNDED_SUCCESS,
  CLEAR_SELECTED_ORDER,
  ORDERS_LOADING,
  ADD_NOTE,
  SET_SELECTED_ORDER,
  SET_ORDER_STATUS_FILTER,
  SET_ORDER_WITHIN_TIME_FILTER,
  JE_ORDER_ACCEPTED_FAILURE,
  JE_ORDER_ACCEPTED_SUCCESS,
  JE_ORDER_ACCEPTED_REQUEST,
  UPDATE_DELIVERY_SLOT_SUCCESS,
  UPDATE_DELIVERY_SLOT_REQUEST,
  UPDATE_DELIVERY_SLOT_FAILURE,
  GET_ADMIN_SETTINGS_REQUEST,
  GET_ADMIN_SETTINGS_SUCCESS,
  GET_ADMIN_SETTINGS_FAILURE,
  SET_AUTO_ACCEPT_REQUEST,
  SET_AUTO_ACCEPT_SUCCESS,
  SET_AUTO_ACCEPT_FAILURE,
  SET_OPEN_STORE_REQUEST,
  SET_OPEN_STORE_SUCCESS,
  SET_OPEN_STORE_FAILURE,
  ALL_ORDERS_FOR_TODAY_TOMORROW_REQUEST,
  GET_CELLS_SUCCESS,
  GET_CELLS_REQUEST,
  GET_CELLS_FAILURE,
  GET_MERCHANTS_IN_CELL_REQUEST,
  GET_MERCHANTS_IN_CELL_SUCCESS,
  GET_MERCHANTS_IN_CELL_FAILURE,
  SET_SELECTED_CELL,
  SEND_NOTIFICATION_REQUEST,
  UPDATE_TAGS_PENDING,
  UPDATE_TAGS_FULFILLED,
  UPDATE_TAGS_FAILED,
  SET_REFRESH_INTERVAL,
  RESEND_ORDER_REQUEST,
  RESEND_ORDER_SUCCESS,
  RESEND_ORDER_FAILURE,
  ALL_ORDERS_FOR_TODAY_TOMORROW_SUCCESS,
  ALL_ORDERS_FOR_TODAY_TOMORROW_FAILURE,
  UPDATE_ACCEPTED_FOR_FAILURE,
  UPDATE_CLIENTS,
  UPDATE_SUGGESTED_DROP_FAILED,
  UPDATE_SUGGESTED_DROP_PENDING,
  UPDATE_SUGGESTED_DROP_FULFILLED,
  GET_ORDER_HISTORY_REQUEST,
  GET_ORDER_HISTORY_SUCCESS,
  GET_ORDER_HISTORY_FAILURE,
  GET_LATEST_EXPECTED_ORDER_TIME_REQUEST,
  GET_LATEST_EXPECTED_ORDER_TIME_SUCCESS,
  GET_LATEST_EXPECTED_ORDER_TIME_FAILURE,
  SET_HOVER_ORDER,
  SET_HOVER_TEAM,
  SET_HOVER_AIRCRAFT,
  SET_ROUTE_CONFIRMATION_ORDER,
  SET_LANE,
  GET_CELL_COMMERCIAL_CONFIG_REQUESTED,
  GET_CELL_COMMERCIAL_CONFIG_SUCCESSFUL,
  GET_CELL_COMMERCIAL_CONFIG_FAILED,
  GET_JUST_EAT_ACTIVE_PENDING,
  GET_JUST_EAT_ACTIVE_FULFILLED,
  GET_JUST_EAT_ACTIVE_FAILED,
  ACTIVATE_JUST_EAT_PENDING,
  ACTIVATE_JUST_EAT_FULFILLED,
  ACTIVATE_JUST_EAT_FAILED,
  DEACTIVATE_JUST_EAT_PENDING,
  DEACTIVATE_JUST_EAT_FULFILLED,
  SET_INVALIDATING_AN_ORDERS_DROP_LOCATION,
  SET_HOVER_DEPARTURE_PAD,
  SET_HOVER_ARRIVAL_PAD,
  UPDATE_DEPARTURE_PAD_PENDING,
  UPDATE_DEPARTURE_PAD_FULFILLED,
  UPDATE_DEPARTURE_PAD_FAILED,
  UPDATE_ARRIVAL_PAD_PENDING,
  UPDATE_ARRIVAL_PAD_FULFILLED,
  UPDATE_ARRIVAL_PAD_FAILED,
  SET_USE_SSE_FOR_ORDERS,
  SET_SHOW_COMPLETED_CANCELLED_ORDERS,
  UPDATE_LANDING_ZONE_LOCALLY,
  ORDER_CARD_UPSERTED,
} from './actionTypes';

import { startLoading, finishLoading, newNotification } from './uiActions';

import { requestOptions } from '../constants';
import { logToDatadog } from 'services/datadog';
import {
  getCellName,
  selectJustEatEnabled,
  selectRefreshInterval,
  selectSelectedCellId
} from 'selectors/ordersSelector';
import { reloadCache } from './adminActions';
import { getEnvironment } from 'services/environment';
import { getLatestJwtToken } from 'services/amplify-auth';
import { orderfulApi } from '../services/api-instances';
import { updateOrderStatus as updateOrderStatusApi } from '../services/order-service';

const ordersApi = new OrdersApi();
ordersApi.accessToken = 'e2d6bd2c866a89c5ac4c1fafd2be727f';
const options = requestOptions;

const getOptions = async () => {
  return {
    headers: {
      'x-api-key': apiKey,
      Authorization: `Bearer ${await getLatestJwtToken()}`
    }
  };
};

export const apiError = err => ({
  type: API_ERROR,
  payload: err,
  meta: { error: err }
});

export const getMergedOrders = orderIds => dispatch => {
  dispatch({ type: API_DATA_REQUESTED });
  dispatch({ type: LOADING });

  let ids = Array.from(orderIds).join(',');
  API.get('api', `/order/mergedOrders?orderIds=${ids}`, options)
    .then(res => {
      dispatch({
        type: MERGED_ORDERS_RECEIVED,
        payload: res
      });

      dispatch({ type: LOADING_DONE });
    })
    .catch(err => {
      dispatch(apiError(err));
      dispatch({ type: LOADING_DONE });
    });
};

export const renderMergedOrders = orders => dispatch => {
  dispatch({
    type: MERGED_ORDERS_RECEIVED,
    payload: orders
  });
};

// Upsert a single Order Hub Card (refresh SSE-backed order list entry)
export const upsertOrderCardById = (orderId) => async dispatch => {
  try {
    const card = await orderfulApi.getOrderCardById(orderId);
    dispatch({
      type: ORDER_CARD_UPSERTED,
      payload: card
    });
  } catch (err) {
    dispatch(apiError(err));
  }
};

export const setOrderStatusFilter = filter => dispatch => {
  dispatch({
    type: SET_ORDER_STATUS_FILTER,
    payload: filter
  });
};

export const setOrderWithinTimeFilter = time => dispatch => {
  dispatch({
    type: SET_ORDER_WITHIN_TIME_FILTER,
    payload: time
  });
};
export const setRefreshInterval = interval => dispatch => {
  dispatch({
    type: SET_REFRESH_INTERVAL,
    payload: interval
  });
};

export const getOrdersForHub = (showLoading, cellId) => (
  dispatch,
  getState
) => {
  const state = getState();
  
  // Skip API call if using SSE for orders
  if (state.orders.useSSEForOrders) {
    return;
  }
  
  if (selectRefreshInterval(getState()) === 0) {
    return;
  }
  if (showLoading) dispatch({ type: ORDERS_LOADING, payload: true });
  let query = `/order/orderHubCards?`;
  const sinceMinutes = getState().orders.timeFilter;
  if (cellId) {
    query += `cellId=${cellId}`;
  } else {
    query += `cellId=${getState().orders.selectedCellId}`;
  }
  if (sinceMinutes) {
    query = query + `&sinceMinutes=${sinceMinutes}`;
  }
  API.get('api', query, options)
    .then(res => {
      dispatch({
        type: ORDERS_RECEIVED,
        payload: { ordersToFilter: res }
      });
      dispatch({ type: ORDERS_LOADING, payload: false });
    })
    .catch(err => {
      dispatch(apiError(err));
      dispatch({ type: ORDERS_LOADING, payload: false });
    });
};

export const getOrders = page => dispatch => {
  API.get('api', `/order/list?page=${page}`, options)
    .then(res => {
      dispatch({
        type: ORDERS_RECEIVED,
        payload: res
      });

      dispatch({ type: LOADING_DONE });
    })
    .catch(err => {
      dispatch(apiError(err));
      dispatch({ type: LOADING_DONE });
    });
};

export const getOrdersCustomer = () => dispatch => {
  API.get('api', `/order/consumerDisplay`, options)
    .then(res => {
      dispatch({
        type: ORDERS_RECEIVED,
        payload: res
      });

      dispatch({ type: LOADING_DONE });
    })
    .catch(err => {
      dispatch(apiError(err));
      dispatch({ type: LOADING_DONE });
    });
};

export const getOrder = orderId => async dispatch => {
  dispatch({ type: API_DATA_REQUESTED });
  dispatch(startLoading());

  return API.get('api', `/order/${orderId}?notes=1`, options)
    .then(res => {
      dispatch(finishLoading());
      dispatch({
        type: ORDER_RECEIVED,
        payload: res
      });
      return res;
    })
    .catch(err => {
      dispatch(apiError(err));
    });
};

export const getLandingZonesInCell = cellId => async dispatch => {
  dispatch({ type: API_DATA_REQUESTED });
  dispatch({ type: LOADING });
  try{
    const res = await API.get('orderful-api', `/cells/${cellId}/landing-zones`, options);
    dispatch({
      type: LANDING_ZONES_RECEIVED,
      payload: res.entities
    });
    dispatch({ type: LOADING_DONE });
  } catch(err) {
      dispatch(apiError(err));
      dispatch({ type: LOADING_DONE });
    };
};

export const getMissions = page => async dispatch => {
  dispatch({ type: API_DATA_REQUESTED });
  dispatch({ type: LOADING });

  try {
    const res = await API.get('api', `/mission/list?page=${page}`, options);
    dispatch({
      type: MISSIONS_RECEIVED,
      payload: res
    });

    dispatch({ type: LOADING_DONE });
  } catch (err) {
    dispatch(apiError(err));
    dispatch({ type: LOADING_DONE });
  }
};

export const getMission = missionId => async dispatch => {
  dispatch({ type: API_DATA_REQUESTED });
  try {
    const res = await API.get('api', `/mission/${missionId}`, options);
    dispatch(finishLoading());
    dispatch({
      type: MISSION_RECEIVED,
      payload: res
    });
    return res;
  } catch (err) {
    dispatch(apiError(err));
  }
};

export const newOrder = ({
  items,
  startLatlng,
  dropLatlng,
  finishLatlng
}) => dispatch => {
  dispatch({ type: API_DATA_REQUESTED });

  const body = {
    basket: {
      items
    },
    startLatlng: `${startLatlng}`,
    dropLatlng: `${dropLatlng}`,
    finishLatlng: `${finishLatlng}`
  };

  API.post('api', '/order', { body }, options)
    .then(() => {
      dispatch({
        type: ORDER_CREATED
      });
      dispatch({
        type: QUEUE_NOTIFICATION,
        payload: {
          variant: 'success',
          message: 'New order created successfully'
        }
      });
    })
    .catch(err => {
      dispatch(apiError(err));
    });
};

export const clearSelectedOrder = () => dispatch => {
  dispatch({ type: CLEAR_SELECTED_ORDER });
};

export const updateOrderStatus = (order, status, eta = 30) => (
  dispatch,
  getState
) => {
  dispatch({ type: API_DATA_REQUESTED });
  if (status === 'ACCEPTED') {
    acceptOrder(order, eta);
  } else {
    return updateOrderStatusApi(order.id, status)
      .then(() => {
        dispatch({
          type: ORDER_STATUS_UPDATED,
          payload: {
            orderId: order.id,
            status
          },
          meta: {
            success: {
              message: `Order ${order.id} status updated to ${status}`
            }
          }
        });
        dispatch(upsertOrderCardById(order.id));
        logToDatadog('update_order_success', { order, eta });
      })
      .catch(err => {
        dispatch(apiError(err));
      });
  }
};

export const acceptOrder = (order, delayInMinutes) => async (dispatch, getState) => {
  dispatch({ type: ORDER_ACCEPTED_REQUEST, payload: delayInMinutes });
  const expectedDeliveryDate = new Date(order.expectedDeliveryDate);
  expectedDeliveryDate.setMinutes(expectedDeliveryDate.getMinutes() + delayInMinutes);
  const expectedDeliveryDateISOString = expectedDeliveryDate.toISOString();
  
  try {
    const baseUrl = process.env.REACT_APP_ORDERFUL_URL;
    const token = await getLatestJwtToken();
    
    const res = await axios.post(`${baseUrl}/orders/accept`, {
      id: order.id, 
      expectedDeliveryDate: expectedDeliveryDateISOString
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });

    dispatch(getOrder(order.id));
    dispatch(upsertOrderCardById(order.id));
    dispatch({ type: ORDER_ACCEPTED_SUCCESS });
    dispatch(
      newNotification({
        variant: 'success',
        message: 'Order accepted successfully'
      })
    );
    logToDatadog('accept_order_success', { order, delayInMinutes });
  } catch (error) {
    dispatch({
      type: ORDER_ACCEPTED_FAILURE,
      meta: { error }
    });
    logToDatadog('failed_accept_order', { order, delayInMinutes, error }, 'ERROR');
  }
};

export const resetOrder = (order, reason) => (dispatch, getState) => {
  return updateOrderStatusApi(order.id, 'RESET', reason)
    .then(() => {
      dispatch(
        newNotification({
          variant: 'success',
          message:
            'Order reset successfully, move status to one of READY, DISPATCHED, CANCELLED'
        })
      );
      dispatch(getOrder(order.id));
      dispatch(upsertOrderCardById(order.id));
      logToDatadog('reset_order_success', { order });
    })
    .catch(err => {
      dispatch(
        newNotification({
          variant: 'error',
          message: `${ORDER_REJECTED_FAILURE} ${err?.response?.data
            ?.errorCode || ''} ${err?.response?.data?.errorMessage ||
            'no error message'} `
        })
      );
      dispatch({
        type: ORDER_REJECTED_FAILURE
      });
      logToDatadog('failed_order_reset', { order }, 'ERROR');
    });
};

export const rejectOrder = (order, reason) => (dispatch, getState) => {
  dispatch({ type: ORDER_REJECTED_REQUEST });
  return ordersApi
    .rejectOrder(order.externalOrderId, {
      RejectReason: reason,
      NotifyCustomer: true
    })
    .then(() => {
      updateOrderStatusApi(order.id, 'REJECTED')
        .then(() => {
          dispatch(
            newNotification({
              variant: 'success',
              message: 'Order rejected successfully'
            })
          );
          dispatch({
            type: ORDER_REJECTED_SUCCESS,
            payload: {
              orderId: order.id,
              status: 'REJECTED'
            }
          });
          dispatch(upsertOrderCardById(order.id));
          logToDatadog('reject_order_success', { order, reason });
        })
        .catch(err => {
          dispatch(
            newNotification({
              variant: 'error',
              message: 'Failed update manna order to rejected'
            })
          );
          dispatch({
            type: ORDER_REJECTED_FAILURE
          });
          logToDatadog('failed_reject_order_manna', { order, reason });
        });
    })
    .catch(err => {
      dispatch({
        type: ORDER_REJECTED_FAILURE,
        meta: { error: err }
      });
      logToDatadog('failed_reject_order_flipdish', { order, reason });
    });
};

export const resendOrder = (orderId, reason, shouldRemakeFood) => dispatch => {
  dispatch({ type: RESEND_ORDER_REQUEST });
  const newOrderStatus = shouldRemakeFood ? 'STORE_ACCEPTED' : 'RECEIVED_FROM_STORE';
  orderfulApi.resendOrder(orderId, reason, newOrderStatus)
    .then(res => {
      dispatch({ type: RESEND_ORDER_SUCCESS });
      dispatch(
        newNotification({
          variant: 'success',
          message: 'Order resent successfully'
        })
      );

      dispatch({
        type: ORDER_RECEIVED,
        payload: res
      });
    })
    .catch(err => {
      dispatch({ type: RESEND_ORDER_FAILURE, meta: { error: err } });
    });
};
export const resetAndResendOrder = (order, reason, shouldRemakeFood) => async dispatch => {
  try {
    await dispatch(resetOrder(order));
    dispatch(resendOrder(order?.id, reason, shouldRemakeFood));
  } catch (err) {
    logToDatadog('Error resetting and resending order.', {err}, 'error')
  }
};

export const fetchOrderHistory = (orderId) => async dispatch => {
  if (!orderId) {
    return;
  }

  try {
    dispatch({
      type: GET_ORDER_HISTORY_REQUEST,
      payload: { orderId }
    });

    const history = await orderfulApi.getOrderHistory(orderId);

    dispatch({
      type: GET_ORDER_HISTORY_SUCCESS,
      payload: { orderId, history }
    });
  } catch (err) {
    dispatch({
      type: GET_ORDER_HISTORY_FAILURE,
      payload: { orderId },
      meta: { error: err }
    });

    dispatch(
      newNotification({
        variant: 'error',
        message: 'Failed to load order activity history'
      })
    );
  }
};

export const fetchLatestExpectedOrderTimeByOrderId = (orderId) => async dispatch => {
  if (!orderId) {
    return null;
  }

  try {
    dispatch({
      type: GET_LATEST_EXPECTED_ORDER_TIME_REQUEST,
      payload: { orderId }
    });

    const expectedOrderTime = await orderfulApi.getLatestExpectedOrderTimeByOrderId(orderId);

    dispatch({
      type: GET_LATEST_EXPECTED_ORDER_TIME_SUCCESS,
      payload: { orderId, expectedOrderTime }
    });

    return expectedOrderTime;
  } catch (err) {
    dispatch({
      type: GET_LATEST_EXPECTED_ORDER_TIME_FAILURE,
      payload: { orderId },
      meta: { error: err }
    });
    return null;
  }
};

export const refundOrder = (order, amount, reason) => (dispatch, getState) => {
  dispatch({ type: ORDER_REFUNDED_REQUEST });
  ordersApi
    .refundOrder(order.externalOrderId, {
      RefundReason: reason,
      RefundAmount: amount,
      NotifyCustomer: true
    })
    .then(() => {
      updateOrderStatusApi(order.id, 'CANCELLED')
        .then(() => {
          dispatch(
            newNotification({
              variant: 'success',
              message: 'Order refunded (CANCELLED) successfully'
            })
          );
          dispatch({
            type: ORDER_REFUNDED_SUCCESS,
            payload: {
              orderId: order.id,
              status: 'REJECTED'
            }
          });
          dispatch(upsertOrderCardById(order.id));
          logToDatadog('refund_order_success', { order, amount, reason });
        })
        .catch(err => {
          dispatch({
            type: ORDER_REFUNDED_FAILURE,
            meta: { error: err }
          });
          logToDatadog(
            'failed_refund_order_manna',
            { order, amount, reason },
            'error'
          );
        });
    })
    .catch(err => {
      dispatch(
        newNotification({
          variant: 'error',
          message: 'Failed refund order with Flipdish'
        })
      );
      dispatch({
        type: ORDER_REFUNDED_FAILURE
      });
      logToDatadog(
        'failed_refund_order_flipdish',
        { order, amount, reason },
        'error'
      );
    });
};

export const acceptJustEatOrder = (orderId, dateTime) => (
  dispatch,
  getState
) => {
  dispatch({ type: JE_ORDER_ACCEPTED_REQUEST });
  API.put(
    'api',
    `/justeat/accept-order/${orderId}?requiredSlot=${dateTime}`,
    {},
    options
  )
    .then(() => {
      dispatch(upsertOrderCardById(orderId));
      dispatch({ type: JE_ORDER_ACCEPTED_SUCCESS });
      dispatch(
        newNotification({
          variant: 'success',
          message: 'Order accepted successfully'
        })
      );
      logToDatadog('accept_just_eat_order_success', { orderId, dateTime });
    })
    .catch(err => {
      dispatch({ type: JE_ORDER_ACCEPTED_FAILURE, meta: { error: err } });
      logToDatadog(
        'failed_accept_just_eat_order',
        { orderId, dateTime },
        'error'
      );
    });
};

export const moveOrderAcceptedForTime = (orderId, time, force = false) => (
  dispatch,
  getState
) => {
  API.put(
    'api',
    `/order/updateAcceptedFor?orderId=${orderId}&yyyyMMddHHmm=${time}&force=${force}`,
    {},
    options
  )
    .then(res => {
      dispatch(upsertOrderCardById(orderId));
      dispatch(
        newNotification({
          variant: 'success',
          message: 'Updated accepted for time'
        })
      );
      logToDatadog('move_order_accepted_time_success', { orderId, time });
    })
    .catch(err => {
      dispatch({ type: UPDATE_ACCEPTED_FOR_FAILURE, meta: { err } });
      logToDatadog(
        'failed_move_order_accepted_time',
        { orderId, time },
        'error'
      );
    });
};

export const mergeOrders = merge => dispatch => {
  dispatch({ type: API_DATA_REQUESTED });

  let ids = [];
  Array.from(merge).forEach(o => {
    ids.push(o.id);
  });
  ids = ids.join(',');
  API.put('api', `/order/mergeDispatch?orderIds=${ids}`, {}, options)
    .then(() => {
      dispatch({
        type: ORDERS_MERGED,
        payload: {
          ids
        }
      });
      // Refresh each affected order card in the SSE-backed list
      Array.from(merge).forEach(o => {
        if (o?.id) {
          dispatch(upsertOrderCardById(o.id));
        }
      });
    })
    .catch(err => {
      dispatch(apiError(err));
    });
};

export const trackOrder = orderId => async dispatch => {
  dispatch({ type: API_DATA_REQUESTED });
  dispatch(startLoading());

  // axios.get(`${mannaApiHost}/order/track/${orderId}?nocache=${new Date().getTime()}`, options)

  axios
    .get(
      `${mannaApiHost}/order/track/${orderId}?nocache=${new Date().getTime()}`,
      await getOptions()
    )
    .then(res => {
      dispatch(finishLoading());
      dispatch({
        type: ORDER_TRACKING_RECEIVED,
        payload: res.data
      });
    })
    .catch(err => {
      dispatch(apiError(err));
    });
};

export const setSelectedOrderId = orderId => {
  return {
    type: SET_SELECTED_ORDER,
    payload: orderId
  };
};

export const updateOrder = (order) => (dispatch) => {
  API.put('api', `/order/${order.id}`, { body: order })
    .catch(err => {
      dispatch(apiError(err));
    });
};

export const addNoteToOrder = (note, orderId) => (dispatch, getState) => {
  dispatch({ type: ADD_NOTE });
  API.post('api', '/order/note', { body: { note, orderId } })
    .then(res => {
      const currentState = getState();

      if (currentState.orders.orderDetails) {
        const newSelectedOrderWithNotes = currentState.orders.orderDetails;
        newSelectedOrderWithNotes.notes = [
          ...newSelectedOrderWithNotes.notes,
          res
        ];
        dispatch({
          type: ORDER_RECEIVED,
          payload: newSelectedOrderWithNotes
        });
      }
    })
    .catch(err => {
      dispatch(apiError(err));
    });
};

const getSlotKeyFromDate = dateString => {
  const date = new Date(dateString);
  const hour = date.getHours();
  let minute = Math.floor(date.getMinutes() / 10) * 10;
  if (minute < 10) {
    minute = '00';
  }
  return parseInt(`${hour}${minute}`);
};

const parseOrdersDataToTimeSlotAvailablitily = fixedSlots => {
  const timeSlotsWithOrders = {};
  fixedSlots.forEach(s => {
    const timeSlotKey = getSlotKeyFromDate(s.startTime);
    timeSlotsWithOrders[timeSlotKey] = {
      available: s.available,
      id: s.id,
      orders: s.orders
    };
  });
  return timeSlotsWithOrders;
};

const splitScheduledSlotsBetweenTodayTomorrow = slots => {
  const todaySlots = [];
  const tomorrowSlots = [];
  slots.forEach(s => {
    if (s.display.includes('Today')) {
      todaySlots.push(s);
    } else {
      tomorrowSlots.push(s);
    }
  });
  return {
    todaySlots,
    tomorrowSlots
  };
};

export const getAllOrdersForTodayAndTomorrowInSlots = cellName => async dispatch => {
  try {
    dispatch({ type: ALL_ORDERS_FOR_TODAY_TOMORROW_REQUEST });
    const slots = await API.get('api', `/order/timetable/${cellName}`);
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    const {
      todaySlots,
      tomorrowSlots
    } = splitScheduledSlotsBetweenTodayTomorrow(slots.scheduled);
    const timeslotAndDayOrders = {
      Today: parseOrdersDataToTimeSlotAvailablitily(todaySlots),
      Tomorrow: parseOrdersDataToTimeSlotAvailablitily(tomorrowSlots)
    };
    dispatch({
      type: ALL_ORDERS_FOR_TODAY_TOMORROW_SUCCESS,
      payload: timeslotAndDayOrders
    });
  } catch (err) {
    dispatch({ type: ALL_ORDERS_FOR_TODAY_TOMORROW_FAILURE });
    dispatch(
      newNotification({
        variant: 'error',
        message: `Failed to get timetable orders for ${cellName}: ` + err
      })
    );
  }
};
export const getSlots = () => async (dispatch, getState) => {
  try {
    const defaultCell = 2; // balbriggan
    const cell = selectSelectedCellId(getState()) || defaultCell;
    dispatch({ type: ALL_ORDERS_FOR_TODAY_TOMORROW_REQUEST });
    const slots = await API.get('api', `/order/orderhub/timetable/${cell}`);

    dispatch({
      type: ALL_ORDERS_FOR_TODAY_TOMORROW_SUCCESS,
      payload: slots
    });
  } catch (err) {
    dispatch({ type: ALL_ORDERS_FOR_TODAY_TOMORROW_FAILURE });
  }
};

export const updateDeliverySlot = (slotId, action, notes) => (
  dispatch,
  getState
) => {
  dispatch({ type: UPDATE_DELIVERY_SLOT_REQUEST });
  API.post('api', '/slot/addHistory', {
    body: {
      slotId: parseInt(slotId),
      action: action,
      note: notes
    },
    options
  })
    .then(res => {
      dispatch({ type: UPDATE_DELIVERY_SLOT_SUCCESS, payload: res });
      dispatch(
        newNotification({
          variant: 'success',
          message: 'Updated delivery slot'
        })
      );
      dispatch(getSlots());
    })
    .catch(err => {
      dispatch({
        type: UPDATE_DELIVERY_SLOT_FAILURE,
        payload: err,
        meta: { error: err }
      });
    });
};

export const updateDeliverySlotForTodayTomorrow = (slotId, action, notes) => (
  dispatch,
  getState
) => {
  dispatch({ type: UPDATE_DELIVERY_SLOT_REQUEST });
  API.post('api', '/slot/addHistory', {
    body: {
      slotId: parseInt(slotId),
      action: action,
      note: notes
    },
    options
  })
    .then(res => {
      dispatch({ type: UPDATE_DELIVERY_SLOT_SUCCESS, payload: res });
      dispatch(
        newNotification({
          variant: 'success',
          message: 'Updated delivery slot'
        })
      );
      dispatch(getAdminConfig());
      dispatch(getSlots());
    })
    .catch(err => {
      dispatch({
        type: UPDATE_DELIVERY_SLOT_FAILURE,
        payload: err,
        meta: { error: err }
      });
    });
};

export const sendEvervaultText = (orderId, msg, sentWith) => {
  return API.post(
    'api',
    '/order/sendTextMessage',
    {
      body: {
        orderId: orderId,
        note: msg,
        sentWith
      }
    },
    options
  );
};

export const sendCustomerComm = (orderId, message) => {
  return API.post(
    'api',
    '/order/sendCommsToCustomer',
    {
      body: {
        orderId,
        note: message
      }
    },
    options
  );
};

export const getAdminConfig = () => (dispatch, getState) => {
  dispatch({ type: GET_ADMIN_SETTINGS_REQUEST });
  const cellName = getCellName(getState()) || 'BALBRIGGAN';

  API.get('delivery', `/availability/${cellName}/manna`)
    .then(res => {
      dispatch({ type: GET_ADMIN_SETTINGS_SUCCESS, payload: res });
    })
    .catch(err => {
      dispatch({
        type: GET_ADMIN_SETTINGS_FAILURE,
        payload: err,
        meta: { error: err }
      });
    });
};

export const updateCell = (cellData) => (dispatch, getState) => {
  orderfulApi.updateCell(cellData)
    .then(() => {
      // reload cell data
      getCells()(dispatch);
    })
    .catch(error => {
      logToDatadog('Error updating cell', {error});
    });
};

export const setAutoAccept = val => (dispatch, getState) => {
  dispatch({ type: SET_AUTO_ACCEPT_REQUEST });
  const cellName = getCellName(getState()) || 'BALBRIGGAN';
  API.get(
    'delivery',
    `/availability/${cellName}/setautoaccepton/${val}?override=1`
  )
    .then(res => {
      dispatch({
        type: SET_AUTO_ACCEPT_SUCCESS,
        payload: val === 1 ? true : false
      });
      reloadCache();
    })
    .catch(err => {
      dispatch({ type: SET_AUTO_ACCEPT_FAILURE, meta: { error: err } });
    });
};

export const setStoreOpen = val => (dispatch, getState) => {
  dispatch({ type: SET_OPEN_STORE_REQUEST });
  const cellName = getCellName(getState()) || 'BALBRIGGAN';
  API.get(
    'delivery',
    `/availability/${cellName}/setstoreopen/${val}?override=1`
  )
    .then(res => {
      const active = val === 1 ? true : false;
      dispatch({ type: SET_OPEN_STORE_SUCCESS, payload: active });
      reloadCache();
    })
    .catch(err => {
      dispatch({ type: SET_OPEN_STORE_FAILURE, meta: { error: err } });
    });
};

export const getCells = () => dispatch => {
  dispatch({ type: GET_CELLS_REQUEST });
  const isProd = getEnvironment() === 'prod';
  API.get('orderful-api', `/cells`)
    .then(res => {
      let cells = res;
      if (isProd) {
        cells = res.filter(c => !!c.active);  // TODO - add this to the API.
      }
      dispatch({
        type: GET_CELLS_SUCCESS,
        payload: cells
      });
    })
    .catch(err => {
      dispatch({ type: GET_CELLS_FAILURE, payload: err, meta: { error: err } });
    });
};

export const getMerchantsInCell = (cellId) => dispatch => {
  dispatch({ type: GET_MERCHANTS_IN_CELL_REQUEST });
  orderfulApi.getAllMerchantsInCell(cellId)
    .then(merchants => {
      dispatch({
        type: GET_MERCHANTS_IN_CELL_SUCCESS,
        payload: merchants
      });
    })
    .catch(err => {
      dispatch({ type: GET_MERCHANTS_IN_CELL_FAILURE, payload: err, meta: { error: err } });
    });
};

export const getCellCommercialConfig = (cellId) => dispatch => {
  dispatch({ type: GET_CELL_COMMERCIAL_CONFIG_REQUESTED });
  orderfulApi.getCellCommercialConfigByCellId(cellId)
    .then(cellCommercialConfig => {
      dispatch({
        type: GET_CELL_COMMERCIAL_CONFIG_SUCCESSFUL,
        payload: cellCommercialConfig
      });
    })
    .catch(err => {
      dispatch({ type: GET_CELL_COMMERCIAL_CONFIG_FAILED, payload: err, meta: { error: err } });
    });
};

export const setSelectedCell = (cellId, skipOrdersLoad = false) => (dispatch, getState) => {
  dispatch({ type: SET_SELECTED_CELL, payload: cellId });
  dispatch(getCellCommercialConfig(cellId));
};

export const sendNotification = ({
  title,
  body,
  cellName,
  targetNotif,
  pushNotifType
}) => async dispatch => {
  dispatch({ type: SEND_NOTIFICATION_REQUEST });

  const targetNotifElement =
    pushNotifType === 'TARGET' ? `&targetNotif=${targetNotif}` : '';

  API.post(
    'delivery',
    `/push?cell=${cellName}&pushNotifType=${pushNotifType}${targetNotifElement}`,
    {
      body: {
        title,
        body
      }
    },
    {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  )
    .then(res => {
      dispatch(
        newNotification({
          variant: 'success',
          message: 'Sending Notification'
        })
      );
    })
    .catch(error => {
      logToDatadog('error_sending_notification', {
        error,
        title,
        body,
        cellName,
        targetNotif,
        pushNotifType
      }, 'error');
      dispatch(
        newNotification({
          variant: 'error',
          message: 'Error sending notification'
        })
      );
    });
};

const updateTagsPending = () => {
  return {
    type: UPDATE_TAGS_PENDING
  };
};
const updateTagsFulfilled = order => {
  return {
    type: UPDATE_TAGS_FULFILLED,
    payload: order
  };
};
const updateTagsFailed = err => {
  return {
    type: UPDATE_TAGS_FAILED,
    meta: { error: err }
  };
};

export const updateTagsThunk = (orderId, tags) => async dispatch => {
  try {
    dispatch(updateTagsPending());
    const res = await API.post(
      'api',
      `/order/tags/${orderId}`,
      { body: tags },
      await getOptions()
    );
    dispatch(updateTagsFulfilled(res));
  } catch (err) {
    dispatch(updateTagsFailed(err));
    throw err;
  }
};

export const updateDeparturePadThunk = (orderId, departurePad) => async dispatch => {
  try {
    dispatch({
      type: UPDATE_DEPARTURE_PAD_PENDING,
      payload: true
    });

    const result = await orderfulApi.updateOriginLandingPad(orderId, departurePad);
    dispatch({
      type: UPDATE_DEPARTURE_PAD_FULFILLED,
      payload: {
        departurePad,
        id: orderId
      }
    });
    logToDatadog('update_departure_pad_success', { orderId, departurePad });
    return result;
  } catch (err) {
    dispatch({
      type: UPDATE_DEPARTURE_PAD_FAILED,
      payload: err,
      meta: { error: err }
    });
    logToDatadog('update_departure_pad_failure', { orderId, departurePad, error: err }, 'ERROR');
    throw err;
  }
};

export const updateArrivalPadThunk = (orderId, arrivalPad) => async dispatch => { 
  try {
    dispatch({
      type: UPDATE_ARRIVAL_PAD_PENDING,
      payload: true
    });
    const result = await orderfulApi.updateDestinationLandingPad(orderId, arrivalPad);
    dispatch({
      type: UPDATE_ARRIVAL_PAD_FULFILLED,
      payload: {
        arrivalPad,
        id: orderId
      }
    });
    logToDatadog('update_arrival_pad_success', { orderId, arrivalPad });
    return result;
  } catch (err) {
    dispatch({
      type: UPDATE_ARRIVAL_PAD_FAILED,
      payload: err,
      meta: { error: err }
    });
    logToDatadog('update_arrival_pad_failure', { orderId, arrivalPad, error: err }, 'ERROR');
    throw err;
  }
};

export const updateClients = clients => {
  return {
    type: UPDATE_CLIENTS,
    payload: clients
  };
};
const updateDropPending = orderId => {
  return {
    type: UPDATE_SUGGESTED_DROP_PENDING,
    payload: orderId
  };
};
const updateDropFulfilled = order => {
  return {
    type: UPDATE_SUGGESTED_DROP_FULFILLED,
    payload: order,
    meta: {
      success: {
        message: `Order drop safety updated`
      }
    }
  };
};
const updateDropFailed = err => {
  return {
    type: UPDATE_SUGGESTED_DROP_FAILED,
    meta: { error: err }
  };
};
export const setHoverOrder = orderId => {
  return {
    type: SET_HOVER_ORDER,
    payload: orderId
  };
};
export const setHoverTeam = hoverTeam => {
  return {
    type: SET_HOVER_TEAM,
    payload: hoverTeam
  };
};
export const setHoverAircraft = aircraft => ({
  type: SET_HOVER_AIRCRAFT,
  payload: aircraft
});

export const setHoverDeparturePad = departurePad => ({
  type: SET_HOVER_DEPARTURE_PAD,
  payload: departurePad
});

export const setHoverArrivalPad = arrivalPad => ({
  type: SET_HOVER_ARRIVAL_PAD,
  payload: arrivalPad
});

export const setRouteConfirmationOrder = order => {
  return {
    type: SET_ROUTE_CONFIRMATION_ORDER,
    payload: order
  };
};

export const setLane = lane => {
  return {
    type: SET_LANE,
    payload: lane
  };
}

export const updateSuggestedDropThunk = (
  orderId,
  latitude = 0,
  longitude = 0
) => async dispatch => {
  try {
    dispatch(updateDropPending(orderId));

    const res = await API.put(
      'api',
      `/order/updateSuggestedDrop?orderId=${orderId}&latitude=${latitude}&longitude=${longitude}`,
      await getOptions()
    );

    dispatch(updateDropFulfilled(res));
  } catch (err) {
    dispatch(updateDropFailed(err));
    throw err;
  }
};
export const clearDropSuggestionsThunk = orderId => async dispatch => {
  try {
    dispatch(updateDropPending(orderId));

    const res = await API.put(
      'api',
      `/order/clearDropSuggestions?orderId=${orderId}`,
      await getOptions()
    );

    dispatch(updateDropFulfilled(res));
  } catch (err) {
    dispatch(updateDropFailed(err));
    throw err;
  }
};
export const finaliseRouteThunk = orderId => async dispatch => {
  try {
    dispatch(updateDropPending(orderId));

    const res = await API.put(
      'api',
      `/order/finaliseRoute?orderId=${orderId}`,
      await getOptions()
    );

    dispatch(updateDropFulfilled(res));
  } catch (err) {
    dispatch(updateDropFailed(err));
    throw err;
  }
};

export const getJustEatActive = () => async dispatch => {
  dispatch({ type: GET_JUST_EAT_ACTIVE_PENDING });
  try{
    const res = await API.get('orderful-api', `/justeat/pool/active`, options);
    dispatch({
      type: GET_JUST_EAT_ACTIVE_FULFILLED,
      payload: res
    });
  } catch(err) {
      dispatch({ type: GET_JUST_EAT_ACTIVE_FAILED });
    };
};
export const activateJustEat = () => async dispatch => {
  dispatch({ type: ACTIVATE_JUST_EAT_PENDING });
  try{
    const res = await API.put('orderful-api', `/justeat/pool/activate`, options);
    dispatch({
      type: ACTIVATE_JUST_EAT_FULFILLED,
      payload: true
    });
  } catch(err) {
      dispatch({ type: ACTIVATE_JUST_EAT_FAILED });
    };
};

export const deactivateJustEat = () => async dispatch => {
  dispatch({ type: DEACTIVATE_JUST_EAT_PENDING });
  try{
    const res = await API.put('orderful-api', `/justeat/pool/deactivate`, options);
    dispatch({
      type: DEACTIVATE_JUST_EAT_FULFILLED,
      payload: false
    });
  } catch(err) {
      dispatch({ type: DEACTIVATE_JUST_EAT_FULFILLED });
    };
};

export const toggleJustEat = () => async (dispatch, getState) => {
  const justEatEnabled = selectJustEatEnabled(getState());
  if (justEatEnabled) {
    dispatch(deactivateJustEat());
  } else {
    dispatch(activateJustEat());
  }
}
  
export const setInvalidatingAnOrderDropLocation = (setInvalidatingAnOrderDropLocation) => { //setInvalidatingAnOrderDropLocation boolean
  return {
    type: SET_INVALIDATING_AN_ORDERS_DROP_LOCATION,
    payload: setInvalidatingAnOrderDropLocation
  };
};

export const setUseSSEForOrders = (useSSEForOrders) => {
  return {
    type: SET_USE_SSE_FOR_ORDERS,
    payload: useSSEForOrders
  };
};

export const setShowCompletedCancelledOrders = (showCompletedOrders) => {
  return {
    type: SET_SHOW_COMPLETED_CANCELLED_ORDERS,
    payload: showCompletedOrders
  };
};

// Optimistic local update of landing zone for an order (UI-first; SSE will reconcile)
export const updateLandingZoneLocally = (orderId, landingZoneId, landingZoneName) => ({
  type: UPDATE_LANDING_ZONE_LOCALLY,
  payload: { id: orderId, landingZoneId, landingZoneName }
});
